import { getBusinessWeekStartDayIndex } from "../../utilities/businessWeek";
import React, { Component } from "react";
import HomeDisplay2 from "./home/HomeDisplay2";

function ContentDisplay2(props) {
  const get7ShiftsIntegration = (storeNames, store_id) => {
    try {
      return storeNames.filter((v, i) => v.id === store_id)[0][
        "scheduling_app_integration_7shifts"
      ];
    } catch (error) {
      return false;
    }
  };


  const getStartQhnum = (storeNames, store_id) => {
    try {
      return storeNames.filter((v, i) => v.id === store_id)[0]["start_qhnum"];
    } catch (error) {
      return 0.0;
    }
  };

  const getScheduleDayEndQhnum = (storeNames, store_id) => {
    try {
      return storeNames.filter((v, i) => v.id === store_id)[0][
        "schedule_day_end_qhnum"
      ];
    } catch (error) {
      return null;
    }
  };

  const getLaborPercentEnabled = (storeNames, store_id) => {
    try {
      return storeNames.filter((v, i) => v.id === store_id)[0][
        "labor_percent_enabled"
      ];
    } catch (error) {
      return false;
    }
  };

  const getPosProvider = (storeNames, store_id) => {
    try {
      return storeNames.filter((v, i) => v.id === store_id)[0][
        "pos_provider"
      ];
    } catch (error) {
      return null;
    }
  };

  const getStoreTimezone = (storeNames, store_id) => {
    try {
      return storeNames.filter((v, i) => v.id === store_id)[0]["timezone"];
    } catch (error) {
      return null;
    }
  };


  return (
    <div className="w-full min-h-screen px-5 py-6">
      <HomeDisplay2
        openLiveAction={props.openLiveAction}
        openDirectMessageWith={props.openDirectMessageWith}
        currentUserId={props.currentUserId}
        openEmployeeProfile={props.openEmployeeProfile}
        scheduleInitialView={props.scheduleInitialView}
        onScheduleInitialViewConsumed={props.onScheduleInitialViewConsumed}
        storeOptions={props.storeOptions}
        homeStore={props.homeStore}
        homeCompany={props.homeCompany}
        storeNames={props.storeNames}
        change_home_store={props.change_home_store}
        has7ShiftsIntegration={get7ShiftsIntegration(
          props.storeNames,
          props.homeStore
        )}
        businessWeekStartDayIndex={getBusinessWeekStartDayIndex(
          props.storeNames,
          props.homeStore
        )}
        laborPercentEnabled={getLaborPercentEnabled(
          props.storeNames,
          props.homeStore
        )}
        pos_provider={getPosProvider(props.storeNames, props.homeStore)}
        start_qhnum={getStartQhnum(props.storeNames, props.homeStore)}
        schedule_day_end_qhnum={getScheduleDayEndQhnum(
          props.storeNames,
          props.homeStore
        )}
        storeTimezone={getStoreTimezone(props.storeNames, props.homeStore)}
        breakWaiverEnabled={props.breakWaiverEnabled}
        defaultBreakLengthHours={props.defaultBreakLengthHours}
        windowWidth={props.windowWidth}
        tplhEnabled={props.tplhEnabled}
        editShiftsInPastEnabled={props.editShiftsInPastEnabled}
        copilotEnabled={props.copilotEnabled}
        scheduleRenderDate={props.scheduleRenderDate}
        setScheduleRenderDate={props.setScheduleRenderDate}
        breakRequiredWhenShiftLengthExceeds={
          props.breakRequiredWhenShiftLengthExceeds
        }
        secondBreakShiftLengthThreshold={
          props.secondBreakShiftLengthThreshold
        }
        proficiencyStarsCount={props.proficiencyStarsCount}
        proficiencyFromLMSEnabled={props.proficiencyFromLMSEnabled}
        printHoursShownEnabled={props.printHoursShownEnabled}
        laborModelEnabled={props.laborModelEnabled}
        laborLawEnabled={props.laborLawEnabled}
        guestReviewsEnabled={props.guestReviewsEnabled}
        liveLaborEnabled={props.liveLaborEnabled}
        fetchBadgeCounts={props.fetchBadgeCounts}
        permissionRole={props.permissionRole}
        permissionOverrides={props.permissionOverrides}
        publishScheduleReviewRequiredEnabled={
          props.publishScheduleReviewRequiredEnabled
        }
        blockPublishOnLaborViolationsEnabled={
          props.blockPublishOnLaborViolationsEnabled
        }
        paidBreakInputsEnabled={props.paidBreakInputsEnabled}
        businessDeclineShiftOptionEnabled={
          props.businessDeclineShiftOptionEnabled
        }
        manualSalesInputEnabled={props.manualSalesInputEnabled}
        dailyPlanEnabled={props.dailyPlanEnabled}
        opsRefreshSignal={props.opsRefreshSignal}
        onScheduleWeekChange={props.onScheduleWeekChange}
        invalidateOverviewCache={props.invalidateOverviewCache}
      />
    </div>
  );
}

export default ContentDisplay2;
